import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ items }) => {
  return (
    <nav 
      aria-label="Breadcrumb" 
      className="flex items-center text-sm text-muted-foreground mb-6"
      data-testid="breadcrumb-nav"
    >
      <ol className="flex items-center flex-wrap gap-1" itemScope itemType="https://schema.org/BreadcrumbList">
        {items.map((item, index) => (
          <li 
            key={item.href || item.label} 
            className="flex items-center"
            itemProp="itemListElement" 
            itemScope 
            itemType="https://schema.org/ListItem"
          >
            {index > 0 && (
              <ChevronRight className="w-4 h-4 mx-1 text-muted-foreground/50" />
            )}
            
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-foreground transition-colors flex items-center gap-1"
                itemProp="item"
                data-testid={`breadcrumb-link-${index}`}
              >
                {index === 0 && <Home className="w-3.5 h-3.5" />}
                <span itemProp="name">{item.label}</span>
              </Link>
            ) : (
              <span 
                className="text-foreground font-medium truncate max-w-[200px] sm:max-w-none"
                itemProp="name"
                data-testid={`breadcrumb-current-${index}`}
              >
                {item.label}
              </span>
            )}
            <meta itemProp="position" content={index + 1} />
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
